module.exports = __webpack_public_path__ + "img/main_genswell.954e4043.png";